import { HStack, Icon, Text } from '@chakra-ui/react';
import { ElementType, ReactNode } from 'react';

type IconProps =
  | {
      icon: ElementType;
      customIcon?: never;
    }
  | { icon?: never; customIcon: ReactNode };

type Props = {
  value: string;
} & IconProps;

export default function IconValue({ value, icon, customIcon }: Readonly<Props>) {
  return (
    <HStack width="100%" gap={1}>
      {customIcon ? customIcon : <Icon as={icon} color="neutral.500" boxSize={{ base: '20px', '4k': '24px' }} />}
      <Text textStyle="screenStd">{value}</Text>
    </HStack>
  );
}
